import appSync from '@/_services/appsync.service.js'
import gql from 'graphql-tag'
import SparkMD5 from 'spark-md5'

export const uploadService = {
  uploadFile,
  getUploadResourceTypeEnum,
  md5Checksum,
  xmlHttpUpload,
  listUploadedFiles,
  getUploadStatus
}
// Patching for issue AW-154
const csvMimeTypes = [
'text/plain',
'text/x-csv',
'application/vnd.ms-excel',
'application/csv',
'application/x-csv',
'text/csv',
'text/comma-separated-values',
'text/x-comma-separated-values',
'text/tab-separated-values'
]

const CREATE_UPLOAD_TASK = gql`mutation createUploadTask($input: CreateUploadTaskInput!) {
  createUploadTask(input: $input) {
    taskID
    url
    key
    bucket
    headers {
      key
      value
    }
  }
}`

async function createUploadTask ({ resource, type, md5, stream }) {
  try {
    const response = await appSync.mutate({
      mutation: CREATE_UPLOAD_TASK,
      variables: {
        input: {
          resource,
          type,
          md5
        }
      },
      fetchPolicy: 'no-cache'
    })
    return { ...response.data.createUploadTask, stream }
  } catch (error) {
    return Promise.reject(error)
  }
}

function md5Checksum ({ file }) {
  return new Promise((resolve, reject) => {
    var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
    const chunkSize = 2097152 // Read in chunks of 2MB
    const spark = new SparkMD5.ArrayBuffer()
    var fileReader = new FileReader()
    let cursor = 0

    function processChunk (chunkStart) {
      const chunkEnd = Math.min(file.size, chunkStart + chunkSize)
      fileReader.readAsArrayBuffer(file.slice(chunkStart, chunkEnd))
    }
    if (!('FileReader' in window) || !('File' in window) || !blobSlice) {
      reject(new Error('Your browser does not support the FileAPI or slicing of files.'))
    }
    fileReader.onload = function (evt) {
      spark.append(evt.target.result) // Accumulate chunk to md5 computation
      cursor += chunkSize // Move past this chunk

      if (cursor < file.size) {
        // Enqueue next chunk to be accumulated
        processChunk(cursor)
      } else {
        // Computation ended, last chunk has been processed. Return as Promise value.
        // This returns the base64 encoded md5 hash, which is what
        // Rails ActiveStorage or cloud services expect
        // console.log(spark.end())
        resolve({ md5: btoa(spark.end(true)), stream: evt.target.result })
        // resolve(spark.end())
        // If you prefer the hexdigest form (looking like
        // '7cf530335b8547945f1a48880bc421b2'), replace the above line with:
        // resolve(spark.end());
      }
    }
    fileReader.onerror = function (evt) {
      reject(new Error('FileReader onerror was triggered, maybe the browser aborted due to high memory usage.'))
    }
    processChunk(0)
  })
}

function uploadFile ({ file, resource }) {
  console.log(file)
  return new Promise((resolve, reject) => {
    let type = false
    // Patching csv mime type for issue AW-154
    if (csvMimeTypes.indexOf(file.type) >= 0) {
      type = 'CSV'
    }
    if (file.type === 'application/json') {
      type = 'JSON'
    }
    if (!type) {
      reject(new Error('Not Correct file type'))
    }
    md5Checksum({ file }).then(({ md5, stream }) => {
      return createUploadTask({
        resource,
        type,
        md5,
        stream
      })
    }).then(({ url, headers, stream }) => {
      const putHeaders = {
        // 'Content-Type': file.type
      }
      headers.forEach(({ key, value }) => {
        putHeaders[key] = value
      })
      const xhr = new XMLHttpRequest()
      xhr.open('PUT', url)
      headers.forEach(({ key, value }) => {
        xhr.setRequestHeader(key, value)
      })
      xhr.onload = () => {
        if (xhr.status === 200) {
          return resolve()
        }
        return reject(new Error(`Status was ${xhr.status}`))
      }
      xhr.onerror = (error) => {
        return reject(error)
      }
      xhr.send(file)
    }).catch((error) => {
      console.error(error)
      reject(error)
    })
    // createUploadTask({
    //   resource,
    //   type
    // }).then((response) => {
    //   console.log(response)
    // })
  })
}

/* ENUMS **/
const GET_UPLOAD_RESOURCE_TYPE_ENUMS = gql`query {
  __type(name: "UploadResourceType") {
     name
     enumValues {
       name
     }
   }
 }`

async function getUploadResourceTypeEnum () {
  try {
    const response = await appSync.query({
      query: GET_UPLOAD_RESOURCE_TYPE_ENUMS,
      fetchPolicy: 'cache'
    })
    return response.data.__type.enumValues
  } catch (error) {
    return Promise.reject(error)
  }
}

function xmlHttpUpload({ url, headers, file  }) {
  return new Promise((resolve, reject) => {
    const putHeaders = {
      // 'Content-Type': file.type
    }
    headers.forEach(({ key, value }) => {
      putHeaders[key] = value
    })
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', url)
    headers.forEach(({ key, value }) => {
      xhr.setRequestHeader(key, value)
    })
    xhr.onload = () => {
      if (xhr.status === 200) {
        return resolve()
      }
      return reject(new Error(`Status was ${xhr.status}`))
    }
    xhr.onerror = (error) => {
      return reject(error)
    }
    xhr.send(file)
  })
}

const LIST_UPLOADED_FILES = gql`query listUploadedFiles($input: ListUploadedFilesInput!) {
  listUploadedFiles(input: $input) {
    nextCursor
    uploads {
      uploadID
      status
      type
      uploadedAt
    }
  }
}`

async function listUploadedFiles({ limit, cursor  }) {
  try {
    const response = await appSync.query({
      query: LIST_UPLOADED_FILES,
      variables: {
        input: {
          limit,
          cursor
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.listUploadedFiles
  } catch (error) {
    return Promise.reject(error)
  }
}

const GET_UPLOAD_STATUS = gql`query getUploadStatus($input: GetUploadStatusInput!) {
  getUploadStatus(input: $input) {
    status
    totalLines
    noOfErrors
    info {
      type
      comment
    }
    errors {
      type
      reference
      reason
    }
  }
}`

async function getUploadStatus({ uploadID }) {
  try {
    const response = await appSync.query({
      query: GET_UPLOAD_STATUS,
      variables: {
        input: {
          uploadID
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.getUploadStatus
  } catch (error) {
    return Promise.reject(error)
  }
}

